"use client";

import type { ColumnDef } from "@tanstack/react-table";

import { DonorDisplay } from "@/components/donor-display";
import { formatMoney, formatTableDate } from "@/lib/format";
import type { TopRecurringDonor } from "@/services/recurringPlans";

const moneyHeaderClass = "justify-end text-right";
const moneyCellClass =
  "w-full text-right tabular-nums whitespace-nowrap text-sm font-semibold text-foreground";

export function getHomeTopRecurringDonorsColumns(
  onPreloadDonor: (donorId: number) => void,
): ColumnDef<TopRecurringDonor, unknown>[] {
  return [
    {
      id: "rank",
      header: "#",
      enableSorting: false,
      cell: ({ row }) => (
        <div className="text-sm text-muted-foreground">{row.index + 1}</div>
      ),
    },
    {
      id: "name",
      header: "Name",
      enableSorting: false,
      cell: ({ row }) => (
        <DonorDisplay
          donorId={row.original.id}
          firstName={row.original.firstName}
          lastName={row.original.lastName}
          onPreload={onPreloadDonor}
        />
      ),
    },
    {
      id: "total",
      header: () => <span className={moneyHeaderClass}>Total</span>,
      enableSorting: false,
      meta: { cellClassName: "text-right" },
      cell: ({ row }) => (
        <div className={moneyCellClass}>
          {formatMoney(row.original.totalCents / 100)}
        </div>
      ),
    },
    {
      id: "started",
      header: "Started",
      enableSorting: false,
      cell: ({ row }) => (
        <div className="whitespace-nowrap text-sm text-muted-foreground">
          {formatTableDate(row.original.planStartDate)}
        </div>
      ),
    },
  ];
}
